import { DetailsEditor } from "uikit"
import React, { Component } from "react"
import { Button, Grid, Icon, Modal } from "semantic-ui-react"
import { useStore } from "store"

const UserIcon = () => <Icon name="settings" size="huge" />

const MethodologyModal = ({ open, onClose }) => {
  const [methodology] = useStore("methodology")
  return (
    <Modal open={open} onClose={onClose} style={{ minHeight: "20em" }}>
      <Modal.Content>
        <Grid className="white">
          <Grid.Row style={{ borderBottom: "1px solid #cccccc" }}>
            <Grid.Column>
              <DetailsEditor
                iconImage={UserIcon}
                heading="Our Methodology"
                description="We use sophisticated analytics models and solution techniques to formulate the advice we give. Please read more about our methodology to understand our strengths and limitations."
              >
                <div className="Agreement" style={{ textAlign: "left" }}>
                  <div dangerouslySetInnerHTML={{ __html: methodology }} />
                </div>
              </DetailsEditor>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
              <Button content="Done" onClick={onClose} primary type="button" />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  )
}

class Methodology extends Component {
  state = { isModalOpen: false }
  handleOpen = () => {
    this.setState({ isModalOpen: true })
  }
  handleClose = () => this.setState({ isModalOpen: false })
  render = () => {
    return (
      <span>
        <span style={{ cursor: "pointer" }} onClick={() => this.handleOpen()}>
          {this.props.LinkTitle ? this.props.LinkTitle : "Our Methodology"}
        </span>

        {this.state.isModalOpen ? (
          <MethodologyModal
            open={this.state.isModalOpen || this.props.open}
            onClose={this.handleClose}
          />
        ) : null}
      </span>
    )
  }
}
export default Methodology
